import script from "./VehicleMileageCorrection.vue?vue&type=script&setup=true&lang=ts"
export * from "./VehicleMileageCorrection.vue?vue&type=script&setup=true&lang=ts"

import "./VehicleMileageCorrection.vue?vue&type=style&index=0&id=2cb71a5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb71a5c"]])

export default __exports__